import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames/bind'
import styles from './styles.scss'
const cx = cn.bind(styles)

const CardIcon = ({ className, disabled, type }) => {
  return (
    <i
      className={cx('container', type.className, className)}
      disabled={disabled}
    />
  )
}

CardIcon.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.object,
}

export default CardIcon
